import { TableDispatchAction, TableSortProperties } from '../../../types/types';
import { TripAggregatedPerformance } from './OverallPerformanceForm';

export default function tableSortReducer(state: TableSortProperties<TripAggregatedPerformance>, action: TableDispatchAction<TripAggregatedPerformance>): TableSortProperties<TripAggregatedPerformance> {
    switch (action.type) {
        case 'CHANGE_SORT': {
            if (state.column === action.column) {
                return {
                    ...state,
                    data: state.data.slice().reverse(),
                    direction: state.direction === 'ascending' ? 'descending' : 'ascending',
                };
            }
            let data = [];
            switch (action.column) {
                case 'tripScheduledStart':
                    data = state.data.sort((a, b) => new Date(a[action.column]).getTime() - new Date(b[action.column]).getTime());
                    break;
                case 'performance':
                case 'fastest':
                case 'scheduledTripTime':
                case 'avgDwell':
                case 'inMotion':
                    data = state.data.sort((a, b) => {
                        const aVal = a[action.column] as number | null;
                        const bVal = b[action.column] as number | null;
                        if (aVal === null)
                            return -1;
                        if (bVal === null)
                            return 1;
                        return aVal - bVal;
                    });
                    break;
                default:
                    data = state.data;
            }
            return {
                column: action.column,
                data: data,
                direction: 'ascending',
            };
        }
        case 'UPDATE_DATA': {
            return {
                ...state,
                data: action.data || [],
            };
        }
    }
}